import { gql } from 'apollo-boost'

const MARK_MENU_SCRAPING_TASK_MISC_AS_VERIFIED = gql`
  mutation markMenuScrapingTaskMiscAsVerified($id: ID!, $comment: String) {
    markMenuScrapingTaskMiscAsVerified(id: $id, comment: $comment) {
      id
      miscTaskVerifiedDate
      miscTaskVerifiedComment
    }
  }
`

export default MARK_MENU_SCRAPING_TASK_MISC_AS_VERIFIED
